import { Notifier } from "@airbrake/browser";

const BLACKLISTED_KEYS = [/password/i, /secret/i, /token/i, /credit_card/i, /gateway/i];

export const initalizeAirbrakeNotifier = ({ config }) => {
  return new Notifier({
    keysBlacklist: BLACKLISTED_KEYS,
    ...config,
  });
};
